import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from '@reduxjs/toolkit';
import { baseApi } from 'common/store/baseApi';
import { triggerError } from 'features/admin/utils/ErrorBoundary/errorSlice';
import { clearCredentials } from 'features/auth/authSlice';
import { clearCredentials as userSliceClearCredential } from 'features/client/services/userSlice';

export const rtkQueryErrorHandler: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    if (action.payload.status === 401 || action.payload.data.message === 'You can not access the resource.') {
      api.dispatch(triggerError({ type: 'UNAUTHENTICATED' }))
    }

    if (action.payload.status === 500 || action.payload?.data?.data === "Invalid ability provided.") {
      // api.dispatch(triggerError({ type: 'UNAUTHORIZED' }))
    }

    // if (action.payload.status === 401) {
    // }

    if (action.payload.status === 401) {
      // You might want to dispatch a logout action at this point and clear state
      api.dispatch(clearCredentials());
      api.dispatch(userSliceClearCredential());
      api.dispatch(baseApi.util.resetApiState());

      // And also dispatch a notification/toast message
      // toast('Your session has expired. Please sign in again.', 'error');
    }
  }

  return next(action);
};
